import { createEffect, sample } from 'effector';
import $$api from 'models/api';
import { $global } from 'models/store-global';

import AlertsService from 'services/AlertsService';

import { MyStore } from 'types/Store';

sample({
    clock: [
        $$api.questionnaires.getQuestionnaireFx.failData,
        $$api.questionnaires.getDocumentTypesFx.failData,
        $$api.questionnaires.getQTypesFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});

// Handle getQuestionnaire success
sample({
    source: $global,
    clock: $$api.questionnaires.getQuestionnaireFx.done.map(({ params: { questionnaireType, state }, result }) => ({
        questionnaireType,
        state,
        result,
    })),
    fn: (global, { questionnaireType, state, result }): MyStore => ({
        ...global,
        questionnaires: {
            ...(global.questionnaires || {}),
            [state]: {
                ...(global.questionnaires?.[state] || {}),
                [questionnaireType]: result,
            },
        } as MyStore['questionnaires'],
    }),
    target: $global,
});
